import {XauditModel} from '../../../xaudit.model';
import {EndoMultiToothExamTeethInExamDataModel} from './endo-multi-tooth-exam-teeth-in-exam-data.model';

export class EndoMultiToothExamDataModel extends XauditModel {
  MTEID: string;
  PatientID: string;
  MTEDate: string;
  Description: string;
  enumToothLocationID: string;
  ProviderDoctorID: string;
  CaseWorkItemFormsId: string;
  OriMTEID: string;

  // Nav Properties
  dataEndoMutiToothExamTeethinExams: EndoMultiToothExamTeethInExamDataModel[] = [];
}
